(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Luxury fade-in on scroll using IntersectionObserver */
  document.addEventListener('DOMContentLoaded', () => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const delay = parseInt(el.dataset.revealIndex || 0) * 30;
            setTimeout(() => { el.classList.add('is-revealed'); }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    function observeItems(container) {
      container.querySelectorAll('.product-grid__item:not(.is-revealed)').forEach((item, i) => {
        item.dataset.revealIndex = i % 4;
        observer.observe(item);
      });
    }

    observeItems(document);

    const grid = document.querySelector('.product-grid');
    if (grid) {
      new MutationObserver(() => observeItems(grid))
        .observe(grid, { childList: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection2"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-split-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    document.querySelectorAll('[data-photoweb-split]').forEach(function (root) {
      // entrance reveal
      if (reduceMotion) {
        root.classList.add('is-visible');
      } else if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                root.classList.add('is-visible');
                observer.unobserve(root);
              }
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(root);
      } else {
        root.classList.add('is-visible');
      }

      // stop mobile video downloads when the merchant opted to show an image instead
      var videoWrap = root.querySelector('[data-video-wrap]');
      if (!videoWrap) return;
      var video = videoWrap.querySelector('video');
      if (!video) return;

      var disableOnMobile = root.getAttribute('data-disable-video-mobile') === 'true';
      if (!disableOnMobile) return;

      var originalSources = null;

      function syncVideoForViewport() {
        if (mobileQuery.matches) {
          if (video.hasAttribute('src') || video.querySelector('source')) {
            originalSources = video.innerHTML;
            video.pause();
            video.removeAttribute('src');
            video.querySelectorAll('source').forEach(function (src) { src.remove(); });
            video.load();
          }
          videoWrap.setAttribute('hidden', '');
        } else {
          videoWrap.removeAttribute('hidden');
          if (originalSources && video.innerHTML === '') {
            video.innerHTML = originalSources;
            video.load();
            video.play().catch(function () {});
          } else {
            video.play().catch(function () {});
          }
        }
      }

      syncVideoForViewport();
      mobileQuery.addEventListener('change', syncVideoForViewport);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-countdown-board"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('sale-countdown-board')) return;

  function pad(n) {
    return String(Math.max(n, 0)).padStart(2, '0');
  }

  class SaleCountdownBoard extends HTMLElement {
    connectedCallback() {
      this.urgencyMs = (parseFloat(this.dataset.urgencyHours) || 24) * 3600 * 1000;
      this.expireBehavior = this.dataset.expireBehavior || 'label';
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.sale-card[data-end]'));
      if (!this.cards.length) return;
      this._tick();
      this._interval = window.setInterval(this._tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this._interval) {
        window.clearInterval(this._interval);
        this._interval = null;
      }
    }

    _tick() {
      var now = Date.now();
      for (var i = 0; i < this.cards.length; i++) {
        this._updateCard(this.cards[i], now);
      }
    }

    _updateCard(card, now) {
      var endStr = card.getAttribute('data-end');
      if (!endStr) return;
      var end = new Date(endStr).getTime();
      if (isNaN(end)) return;

      var diff = end - now;

      if (diff <= 0) {
        if (!card.classList.contains('sale-card--expired')) {
          card.classList.add('sale-card--expired');
          var overlay = card.querySelector('[data-expired-overlay]');
          if (overlay) overlay.hidden = false;
          if (this.expireBehavior === 'hide') {
            card.classList.add('sale-card--hidden');
          }
        }
        this._setTimerText(card, 0, 0, 0, 0);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      this._setTimerText(card, days, hours, minutes, seconds);

      if (diff <= this.urgencyMs) {
        card.classList.add('sale-card--urgent');
      } else {
        card.classList.remove('sale-card--urgent');
      }
    }

    _setTimerText(card, d, h, m, s) {
      var timer = card.querySelector('[data-timer]');
      if (!timer) return;
      var dEl = timer.querySelector('[data-d]');
      var hEl = timer.querySelector('[data-h]');
      var mEl = timer.querySelector('[data-m]');
      var sEl = timer.querySelector('[data-s]');
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
  }

  customElements.define('sale-countdown-board', SaleCountdownBoard);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-buttons-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-pwbtns]').forEach(function (root) {
      if (reduceMotion) {
        root.classList.add('is-visible');
        return;
      }
      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-visible');
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-visible');
              observer.unobserve(root);
            }
          });
        },
        { threshold: 0.2 }
      );
      observer.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
